import Tracker from './Tracker';

const BillingTracker = new Tracker('Billing', {
	REQUESTED_ADDON: 'requested_addon',
	BOUGHT_ADDON: 'bought_addon',
	BOUGHT_AI_AGENT: 'bought_ai_agent',
	STARTED_ADDON_TRIAL: 'started_addon_trial',
	VIEWED_ADDONS_PAGE: 'viewed_addons_page',
	VIEWED_AI_AGENTS_PAGE: 'viewed_ai_agents_page',
	ADDON_READ_MORE: 'addon_read_more',
	AI_AGENT_READ_MORE: 'ai_agent_read_more',
	OPEN_ADDON_TERMS: 'open_addon_terms',
	ABORTED_ADDON_PURCHASE: 'aborted_addon_purchase',
	ADD_SEATS: 'add_seats',
	REMOVE_SEATS: 'remove_seats',
	ADD_SUPPORT_SEATS: 'add_support_seats',
	REMOVE_SUPPORT_SEATS: 'remove_support_seats'
});

export default BillingTracker;
